import classNames from 'classnames';

import { ButtonProps } from './Button.type';

const iconSizeStyles = {
  xs: 'w-[30px] h-[32px] gap-[2px] rounded-[6px_6px_6px_6px]',
  s: 'w-[36px] h-[36px] gap-[2px] rounded-[8px_8px_8px_8px]',
  m: 'w-[44px] h-[44px] gap-[2px] rounded-[12px_12px_12px_12px]',
  l: 'w-[50px] h-[50px] gap-[4px] rounded-[14px_14px_14px_14px]',
};

const sizeStyles = {
  xs: 'w-[96px] min-w-fit h-[32px] p-[6px_12px] gap-[4px] rounded-[6px_6px_6px_6px]',
  s: 'w-[122px] min-w-fit h-[36px] p-[9px_12px] gap-[6px] rounded-[8px_8px_8px_8px]',
  m: 'w-[148px] min-w-fit h-[44px] p-[10px_16px] gap-[6px] rounded-[12px_12px_12px_12px]',
  l: 'w-[171px] min-w-fit h-[52px] p-[14px_20px] gap-[8px] rounded-[14px_14px_14px_14px]',
};

export const getButtonClass = (
  variant: ButtonProps['variant'],
  className?: string,
  isIcon?: boolean,
  size: ButtonProps['size'] = 'm',
) => {
  return classNames(
    'button cursor-pointer transition duration-200 text-base font-semibold',
    className,
    isIcon ? iconSizeStyles[size] : sizeStyles[size],
    {
      'bg-primary-50 text-white-100 hover:bg-primary-40': variant === 'primary' || !variant,
      'bg-white-100 text-black hover:bg-neutral-20 border border-neutral-20':
        variant === 'secondary',
      'bg-success-50 text-white-100 hover:bg-success-40': variant === 'success',
      'bg-warning-50 text-white-100 hover:bg-warning-40': variant === 'warning',
      'bg-danger-50 text-white-100 hover:bg-danger-40': variant === 'danger',
      'bg-transparent text-black border border-primary-20 hover:border-primary-40':
        variant === 'transparent',
    },
  );
};
